export default import.meta.ROLLUP_FILE_URL_3WU_f8RF;